import { defineMessages } from 'react-intl'

const messages = defineMessages({
  useMyCredit: {
    id: 'staywallet.use-my-credit',
  },
})

export default messages
